import { defineStore } from 'pinia'
import axios from '@/services/index.js'

export const useTransportsStore = defineStore('transports', {
  modelName: 'Transport',
  state: () => ({
    transports: [],
    totalItems: 0,
    loading: false,
    error: null
  }),

  getters: {
    showTransports: (state) => state.transports
  },

  actions: {
    onModelChanged() {
      this.fetchTransports()
    },

    // Obtener lista paginada de transportes
    async fetchTransports(params = {}) {
      this.loading = true
      this.error = null

      try {
        const response = await axios.get('/api/transports', { params })

        if (response.data) {
          this.transports = response.data.data || []
          this.totalItems = response.data.total || 0
          return response.data
        }

        throw new Error('Error al cargar transportes')
      } catch (error) {
        this.error = error.response?.data?.message || error.message
        throw error
      } finally {
        this.loading = false
      }
    },

    // Crear nuevo transporte
    async createTransport(transportData) {
      this.loading = true
      this.error = null

      try {
        const response = await axios.post('/api/transports', transportData)

        if (response.data) {
          return response.data
        }

        throw new Error('Error al crear transporte')
      } catch (error) {
        this.error = error.response?.data?.message || error.message
        throw error
      } finally {
        this.loading = false
      }
    },

    // Actualizar transporte existente
    async updateTransport(id, transportData) {
      this.loading = true
      this.error = null

      try {
        const response = await axios.put(`/api/transports/${id}`, transportData)

        if (response.data) {
          return response.data
        }

        throw new Error('Error al actualizar transporte')
      } catch (error) {
        this.error = error.response?.data?.message || error.message
        throw error
      } finally {
        this.loading = false
      }
    },

    // Eliminar transporte
    async deleteTransport(id) {
      this.loading = true
      this.error = null

      try {
        const response = await axios.delete(`/api/transports/${id}`)

        if (response.data) {
          return response.data
        }

        throw new Error('Error al eliminar transporte')
      } catch (error) {
        this.error = error.response?.data?.message || error.message
        throw error
      } finally {
        this.loading = false
      }
    },

    // Método legacy para compatibilidad
    async getTransports() {
      try {
        this.loading = true
        const response = await axios.get('/api/transports/getTransports')
        this.transports = response.data.data
      } catch (error) {
        this.transports = error.response
      } finally {
        this.loading = false
      }
    },

    // Obtener lista de transportes (endpoint legacy list)
    async fetchTransportsList(params = {}) {
      this.loading = true
      try {
        const response = await axios.get('/api/transports/list', { params })

        if (response.data) {
          this.transports = response.data.data || []
          this.totalItems = response.data.recordsTotal || 0
          return {
            data: response.data.data || [],
            recordsTotal: response.data.recordsTotal || 0
          }
        }

        return { data: [], recordsTotal: 0 }
      } catch (error) {
        console.error('Error fetching transports list:', error)
        throw error
      } finally {
        this.loading = false
      }
    },

    // Obtener un transporte específico (endpoint legacy)
    async fetchTransport(id) {
      try {
        const response = await axios.get(`/api/transports/getTransport/${id}`)
        return response.data.data
      } catch (error) {
        console.error('Error fetching transport:', error)
        throw error
      }
    },

    // Crear transporte (endpoint legacy)
    async addTransport(transportData) {
      try {
        const response = await axios.post('/api/transports/add', transportData)
        return response.data
      } catch (error) {
        console.error('Error adding transport:', error)
        throw error
      }
    },

    // Actualizar transporte (endpoint legacy)
    async editTransport(id, transportData) {
      try {
        const response = await axios.post(`/api/transports/edit/${id}`, transportData)
        return response.data
      } catch (error) {
        console.error('Error editing transport:', error)
        throw error
      }
    },

    // Eliminar transporte (endpoint legacy POST)
    async removeTransport(id) {
      try {
        const response = await axios.post('/api/transports/delete', { id })
        return response.data
      } catch (error) {
        console.error('Error removing transport:', error)
        throw error
      }
    }
  }
})